import useOrigin from '@/helper/useOrigin.js';
import { getNewSessionId } from '../api/fetchParams';

export default class GameCommunicatorPNG {
  vm = undefined;
  targetOrigin = undefined;
  source = undefined;

  constructor(vm) { this.vm = vm }

  init (iframeRef) {
    window.addEventListener('message', this.processGameMessage.bind(this));
    this.targetOrigin = useOrigin(this.vm.$route.query.gameURL);
    this.source = iframeRef;
  }
  postMessage (data) {
    switch (data) {
      case 'autoplayOff':
        data = { messageType: 'request', request: 'stopAutoplay' }
        break;
      case 'stopGame':
        data = { messageType: 'request', request: 'gameDisable' }
        break;
      case 'resumeGame':
        data = { messageType: 'request', request: 'gameEnable' }
        break;
    }
    console.log('GameCommunicator sent the following message: ', data);
    this.source.contentWindow.postMessage(data, this.targetOrigin);
  }
  processGameMessage (e) {
    switch (e.data.type) {
      case 'reloadGame':
        this.reloadGame();
        break;
      case 'backToLobby':
        this.vm.onExitGamePlatform();
        break;
      case 'autoplayEnded':
        this.vm.autoplayStopped();
        break;
      case 'autoplayStarted':
        this.vm.autoplayStarted();
        break;
      case 'gameDisabled':
        this.vm.gameStopped();
        break;
      case 'gameEnabled':
        this.vm.gameStarted();
        break;
    }
  }
  async reloadGame () {
    const oldGameURL = new URLSearchParams(this.vm.gameFrameUrl);
    const oldTicket = oldGameURL.get('ticket');
    const newTicket = await getNewSessionId(oldTicket);
    let query;
    let path;

    if (newTicket) {
      this.postMessage({ messageType: 'request', eventType: 'reloadGame' });
      oldGameURL.set('ticket', newTicket);
      const gameURL = decodeURIComponent(oldGameURL.toString());
      query = { ...this.vm.$route.query, gameURL };
      path = this.vm.$route.path;
    } else {
      query = {
        text: 'Game reload failed',
        languageCode: 'en',
        type: 'error',
        errorCode: 'ERReload',
        closeurl: this.vm.$route.query.closeurl
      };
      path = '/MessageView';
    }
    this.vm.$router.push({ path, query });
  }
}
